import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router-dom";
// import ImagingSearchAccordion from "../../../ImagingSearchAccordion/ImagingSearchAccordion";
import searchBarStyles from "./SearchBar.module.css";

let searchCarouselLastItem = undefined;
let searchCarouselId = "";

const SearchBar = () => {
  const history = useHistory();
  const searchCarouselItems = ["Tests", "MRI", "XRAY"];
  // const [lastItemIndex, setLastItemIndex] = useState(1);
  // const [showSearchAccordion, setShowSearchAccordion] = useState(false);

  const startSearchCarousel = () => {
    const newId = setInterval(() => {
      let itemContainer = document.getElementById("search-carousel");
      if (!itemContainer)
        return;
      itemContainer.classList.add(searchBarStyles.searchCarouselRotate);
      // let item1 = document.getElementById("search-carousel-item1");
      // console.log("item1", item1);
      // let item2 = document.getElementById("search-carousel-item2");
      // console.log("item2", item2);
      let item1Value = document.getElementById("search-carousel-item2").innerHTML;
      let item2Value = searchCarouselItems[((searchCarouselLastItem + 1) % searchCarouselItems.length)];
      // setLastItemIndex((lastItemIndex + 1) % searchCarouselItems.length);
      searchCarouselLastItem = ((searchCarouselLastItem + 1) % searchCarouselItems.length);
      setTimeout((item1Value, item2Value) => {
        let item1 = document.getElementById("search-carousel-item1");

        let item2 = document.getElementById("search-carousel-item2");

        // let item1Value = searchCarouselItems[(currentItemIndex + 1) % searchCarouselItems.length];
        // let item2Value = searchCarouselItems[(currentItemIndex + 2) % searchCarouselItems.length];
        item1 ? item1.innerHTML = item1Value : "";
        itemContainer.classList.remove(searchBarStyles.searchCarouselRotate);
        item2 ? item2.innerHTML = item2Value : "";
        // setCurrentItemIndex((currentItemIndex + 1) % searchCarouselItems.length);
        // searchCarouselLastItem = ((searchCarouselLastItem + 1) % searchCarouselItems.length);
      }, 1200, item1Value, item2Value)
    }, 1500)

    searchCarouselId = newId;
  }

  useEffect(() => {
    // document.getElementById("search-carousel").classList.add(searchBarStyles.searchCarouselRotate);
    if (searchCarouselLastItem === undefined) {
      searchCarouselLastItem = 1;
    }
    if (searchCarouselId) {
      clearInterval(searchCarouselId);
      searchCarouselId = ""
    }
    if (!searchCarouselId && !history.location.pathname.includes("/search")) {
      startSearchCarousel();
    }
  }, [])

  // useEffect(() => {
  //   if (showSearchAccordion === false && searchCarouselId === "") {
  //     startSearchCarousel();
  //   }
  //   if (showSearchAccordion === true) {
  //     // console.log("Search Carousel Clear Interval", searchCarouselId);
  //     clearInterval(searchCarouselId);
  //     searchCarouselId = "";
  //   }
  // }, [showSearchAccordion, searchCarouselId])

  const handleSearchClick = () => {
    history.push("/imaging/search")
  }

  return (
    <>
      <div className={searchBarStyles.searchInput}>
        <FaSearch
          className={searchBarStyles.searchIcon}
        />
        {/* <input
          type="button"
          // className={searchBarStyles.searchButtonNew}
          defaultValue="Search Tests"
          // onFocus={(e) => {
          //   e.target.select(), setDisplay1(true);
          // }}
          onClick={() => !showSearchAccordion && setShowSearchAccordion(true)}
        /> */}

        <div className={searchBarStyles.searchContainer} onClick={handleSearchClick}>
          <span>Search</span>
          <div className={searchBarStyles.searchCarouselContainer}>
            <div id="search-carousel" className={`${searchBarStyles.searchCarousel}`}>
              <span id="search-carousel-item1">XRAY</span>
              <span id="search-carousel-item2">MRI</span>
            </div>
          </div>
        </div>
      </div>
      {/* {showSearchAccordion
        ? <ImagingSearchAccordion setShowSearchAccordion={setShowSearchAccordion} />
        : null
      } */}
    </>
  )
}

export default SearchBar;